// extracted by mini-css-extract-plugin
module.exports = {"container":"i_EH","tab":"i_EI","selected-tab":"i_EJ"};